import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var supersetReportingURL = {
    supersetMenuList: URLConfig.config.apiBase +
        microService.masterSevice +
        "v2/Common/supersetdashboards",
    GetGuestTokenAndEmbed: URLConfig.config.apiBase + microService.userService + "superset/Token",
};
export default supersetReportingURL;
